




















































































































































































import {
  defineNuxtComponent,
  PropType,
  ref,
  computed
} from '~/utils/nuxt3-migration'
import { ciTimes } from '~/icons/source/regular/times'
import { ciAngleDown } from '~/icons/source/regular/angle-down'
import { ciAngleUp } from '~/icons/source/regular/angle-up'
import { ciArrowLeft } from '~/icons/source/regular/arrow-left'
import { ciArrowRight } from '~/icons/source/solid/arrow-right'
import { useUserAgent } from '~/compositions/user-agent'

interface Step {
  title: string
  content: string
  img: string
}

export default defineNuxtComponent({
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    mainImg: {
      type: String,
      default: ''
    },
    expandedImg: {
      type: String,
      default: '',
      required: false
    },
    steps: {
      type: Array as PropType<Step[]>,
      required: false,
      default: () => []
    },
    expanded: {
      type: Boolean,
      default: false
    },
    dismissible: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { isPc, isMobile } = useUserAgent()

    const isExpanded = ref(props.expanded)
    const currentStep = ref(0)

    // for expanded info with steps, we show the step image
    // otherwise we show expanded image and if not available, we show the main image
    // if not expanded, we show the main image
    const imgSrc = computed(() => {
      if (!isExpanded.value) return props.mainImg

      return hasSteps.value
        ? props.steps[currentStep.value].img
        : props.expandedImg || props.mainImg
    })

    const expandedTitle = computed(() => {
      return hasSteps.value ? props.steps[currentStep.value].title : props.title
    })

    const hasSteps = computed(() => props.steps && props.steps.length > 0)

    function toggleExpand() {
      isExpanded.value = !isExpanded.value
    }

    function onDismissClick() {
      emit('dismiss')
    }

    function goToStep(step: number) {
      currentStep.value = step
    }

    return {
      ciAngleDown,
      ciAngleUp,
      ciTimes,
      ciArrowRight,
      ciArrowLeft,
      isMobile,
      isPc,
      isExpanded,
      imgSrc,
      expandedTitle,
      currentStep,
      toggleExpand,
      onDismissClick,
      goToStep,
      hasSteps
    }
  }
})
